<template>
    <rkm-overlay>
        <rkm-layout-body title="Cancelamento de resultado">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
            </template>
            <rkm-layout-content v-if="loaded">
                <Form
                    :data="{ form }"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/exame-laboratorial/cancelamento-resultado/Form'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            entrega: this.getConectaSusRepository('exameLaboratorial.cancelamentoResultado')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.entrega.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {

            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'dashboard' })
        }
    },
    mixins: [repository, error, object, data]
}
</script>